import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import { StoreProductOrder } from "../../StoreProductOrder";
import { memberPackageIdAtom, orderIdAtom } from "../atoms";
import { StorePackagePurchaseQuery } from "./__generated__/StorePackagePurchaseQuery.graphql";

export const StorePackagePurchase = () => {
  const orderId = useAtomValue(orderIdAtom);
  const memberPackageId = useAtomValue(memberPackageIdAtom);

  const [queryRef, loadQuery] = useQueryLoader<StorePackagePurchaseQuery>(
    StorePackagePurchaseQueryString
  );

  useEffect(() => {
    if (orderId && memberPackageId) {
      loadQuery(
        { orderId, memberPackageId },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [loadQuery, memberPackageId, orderId]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? <StorePackagePurchaseInner queryRef={queryRef} /> : null}
    </Suspense>
  );
};

const StorePackagePurchaseInner = ({
  queryRef,
}: {
  queryRef: PreloadedQuery<StorePackagePurchaseQuery>;
}) => {
  const data = usePreloadedQuery(StorePackagePurchaseQueryString, queryRef);

  const memberPackage = data.memberPackage;
  const order = data.order;

  return (
    <StoreProductOrder memberPackageRef={memberPackage} orderRef={order} />
  );
};

const StorePackagePurchaseQueryString = graphql`
  query StorePackagePurchaseQuery($orderId: ID!, $memberPackageId: ID!) {
    memberPackage: node(id: $memberPackageId) {
      ... on MemberPackage {
        ...StoreProductOrder_memberPackage
      }
    }
    order: node(id: $orderId) {
      ... on Order {
        ...StoreProductOrder_order
      }
    }
  }
`;
